import React from 'react';
import { Users, AlertTriangle, TrendingUp, ArrowUpRight } from 'lucide-react';
import { RiskList } from '../../components/admin/RiskList';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
export function AdminDashboard() {
  return <div className="space-y-8" data-id="element-215">
      <div className="flex justify-between items-end" data-id="element-216">
        <div data-id="element-217">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-218">
            Monitoramento de Risco
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-219">
            Visão geral da saúde da base de alunos.
          </p>
        </div>
        <div className="text-sm text-gray-500" data-id="element-220">Atualizado há 5 min</div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-221">
        <Card className="border-l-4 border-l-red-500" data-id="element-222">
          <div className="flex justify-between items-start" data-id="element-223">
            <div data-id="element-224">
              <p className="text-sm font-medium text-gray-500" data-id="element-225">
                Alunos em Risco Alto
              </p>
              <h3 className="text-3xl font-bold text-gray-900 mt-2" data-id="element-226">12</h3>
            </div>
            <div className="p-2 bg-red-100 rounded-lg text-red-600" data-id="element-227">
              <AlertTriangle size={24} data-id="element-228" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm text-red-600 font-medium" data-id="element-229">
            <ArrowUpRight size={16} className="mr-1" data-id="element-230" />
            +2 desde ontem
          </div>
        </Card>

        <Card className="border-l-4 border-l-[var(--success)]" data-id="element-231">
          <div className="flex justify-between items-start" data-id="element-232">
            <div data-id="element-233">
              <p className="text-sm font-medium text-gray-500" data-id="element-234">
                Recuperados (Mês)
              </p>
              <h3 className="text-3xl font-bold text-gray-900 mt-2" data-id="element-235">45</h3>
            </div>
            <div className="p-2 bg-green-100 rounded-lg text-green-600" data-id="element-236">
              <Users size={24} data-id="element-237" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm text-green-600 font-medium" data-id="element-238">
            <TrendingUp size={16} className="mr-1" data-id="element-239" />
            Taxa de sucesso: 78%
          </div>
        </Card>

        <Card className="border-l-4 border-l-[var(--primary)]" data-id="element-240">
          <div className="flex justify-between items-start" data-id="element-241">
            <div data-id="element-242">
              <p className="text-sm font-medium text-gray-500" data-id="element-243">Churn Evitado</p>
              <h3 className="text-3xl font-bold text-gray-900 mt-2" data-id="element-244">R$ 4.5k</h3>
            </div>
            <div className="p-2 bg-orange-100 rounded-lg text-[var(--primary)]" data-id="element-245">
              <TrendingUp size={24} data-id="element-246" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500" data-id="element-247">
            Receita mensal preservada
          </div>
        </Card>
      </div>

      {/* Main List */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-248">
        <div className="lg:col-span-2" data-id="element-249">
          <RiskList data-id="element-250" />
        </div>

        <div className="space-y-6" data-id="element-251">
          <Card data-id="element-252">
            <h3 className="font-bold text-gray-900 mb-4" data-id="element-253">Ações Pendentes</h3>
            <div className="space-y-4" data-id="element-254">
              <div className="flex items-start gap-3 pb-4 border-b border-gray-100" data-id="element-255">
                <div className="w-2 h-2 mt-2 rounded-full bg-red-500 flex-shrink-0" data-id="element-256" />
                <div data-id="element-257">
                  <p className="text-sm font-medium text-gray-900" data-id="element-258">
                    Ligar para Pedro Costa
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-259">Ausente há 21 dias</p>
                </div>
              </div>
              <div className="flex items-start gap-3 pb-4 border-b border-gray-100" data-id="element-260">
                <div className="w-2 h-2 mt-2 rounded-full bg-yellow-500 flex-shrink-0" data-id="element-261" />
                <div data-id="element-262">
                  <p className="text-sm font-medium text-gray-900" data-id="element-263">
                    Enviar msg para Ana Silva
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-264">
                    Queda de 80% na frequência
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-265">
                <div className="w-2 h-2 mt-2 rounded-full bg-blue-500 flex-shrink-0" data-id="element-266" />
                <div data-id="element-267">
                  <p className="text-sm font-medium text-gray-900" data-id="element-268">
                    Parabenizar Mariana
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-269">Retorno após 15 dias</p>
                </div>
              </div>
            </div>
            <Button variant="outline" size="sm" className="w-full mt-4" data-id="element-270">
              Ver Todas
            </Button>
          </Card>

          <Card className="bg-gradient-to-br from-[var(--secondary)] to-gray-800 text-white" data-id="element-271">
            <h3 className="font-bold mb-2" data-id="element-272">Dica do Sistema</h3>
            <p className="text-sm text-gray-300 mb-4" data-id="element-273">
              Alunos que recebem contato na 3ª semana de ausência têm 60% mais
              chance de retornar.
            </p>
            <Button size="sm" className="w-full bg-white text-[var(--secondary)] hover:bg-gray-100" data-id="element-274">
              Automatizar Mensagens
            </Button>
          </Card>
        </div>
      </div>
    </div>;
}